var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('van-nav-bar',{attrs:{"title":"购票须知","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('display-description',{staticStyle:{"marginBottom":"100px"},attrs:{"value":_vm.description}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }